<template>
    <div>
		<!-- Fornecedores do produto --> 
        <div class="modal fade" id="mdfornecedores" tabindex="-1">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-search" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title">Fornecedores do produto</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body" style="padding-bottom: 0px;">
                        <div class="row"> 
                            <div class="col-md-12">
                                <div class="alert alert-success text-center" style="padding: 5px; background-color: #4250f2; border-color: #4250f2;">
                                    <strong style="font-size: 16px; color: #f3f1f1;">{{ idproduto }} - {{ descricao }}</strong>
                                </div>                                
                            </div>
                            <div class="col-lg-12">
                                <div class="table-responsive" style="border-radius: 0px !important;">
                                    <table class="table table-bordered table-sm table-hover">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th width="30"></th>
                                                <th>Fornecedor:</th>
                                                <th>Qtd Notas:</th>
                                                <th>Total Notas:</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(fornecedor, index) in lstfornecedoresproduto">
                                                <tr v-bind:key="index">
                                                    <td class="text-center">
                                                        <span v-if="parseFloat(fornecedor.expandir) === 0" style="font-size: 20px; cursor: pointer;" @click.prevent="mtdexpandirnotas(index)"><i class="fa fa-chevron-circle-down text-primary"></i></span>
                                                        <span v-else style="font-size: 20px; cursor: pointer;"><i class="fa fa-chevron-circle-up text-primary" @click.prevent="mtdexpandirnotas(index)"></i></span>													
                                                    </td>                                                
                                                    <td style="font-weight: 600;">{{ fornecedor.idfornecedor }} - {{ fornecedor.fantasia }}</td>
                                                    <td style="font-weight: 600; text-align: right;">{{ fornecedor.qtdnotas }}</td>
                                                    <td style="font-weight: 600; text-align: right;">{{ formatavalores(parseFloat(fornecedor.totalnotas)) }}</td>
                                                </tr>
                                                <tr v-bind:key="index">
                                                    <td colspan="11" v-show="parseInt(fornecedor.expandir) === 1">
                                                        <table id="tbclista" class="table table-bordered table-sm table-hover" style="margin-top: 2px; margin-bottom: 2px;">
                                                            <thead class="thead-dark">
                                                                <tr>
                                                                    <th width="50">Nr. Nota</th>
                                                                    <th width="50">Emissão:</th>
                                                                    <th width="100">Filial:</th>
                                                                    <th width="50">Pr. Compra:</th>
                                                                    <th width="50">Pr. Custo:</th>
                                                                    <th width="30">Qtd:</th>
                                                                    <th width="50" >Vl. Desconto:</th>
                                                                    <th width="50">Vl. Total:</th>
                                                                    <th width="50">Estoque:</th>
                                                                </tr>																								
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, indexp) in fornecedor.itens" style="font-size: 12px;" :key="indexp">
                                                                    <td>{{item.numero}}</td>
                                                                    <td style="text-align: right;">{{item.dtemissao}}</td>
                                                                    <td>{{item.idfilial}} - {{item.fantasia}}</td>
                                                                    <td style="text-align: right;">{{mtdformatavalordecimal(item.prcompra, 2)}}</td>
                                                                    <td style="text-align: right;">{{mtdformatavalordecimal(item.vprcusto, 2)}}</td>
                                                                    <td style="text-align: right;">{{item.qtditem}}</td>
                                                                    <td style="text-align: right;">{{mtdformatavalordecimal(item.vdesconto, 2)}}</td>
                                                                    <td style="text-align: right;">{{mtdformatavalordecimal(item.vvtotal, 2)}}</td>
                                                                    <td>{{item.descestoque}}</td>
                                                                </tr>	
                                                            </tbody>
                                                        </table>													
                                                    </td>
											    </tr>                                                
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>                 
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Sair</button>
                    </div>                          
                </div>
            </div>
        </div>                                   
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpfornecedoresproduto',
    props:[
                'idproduto',
                'descricao'
          ],
    data: function() {
        return {
            lstfornecedoresproduto : []
        };
    },
    methods: {
        formatavalores:function (val) {
            return util.formatarvalor(val, '');
        },       
        mtdfornecedoresproduto(){
            var vself           = this;
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor  : 'fornecedores'},
                {parametro: 'idproduto',    valor  : vself.idproduto}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
            retorno.then(function (response) {
                if (response.data.length === 0){
                    vself.$toastr.i('Não há registros de compras para o produto informado!', 'Informação!');
                }else{
                    vself.lstfornecedoresproduto = [];
                    vself.lstfornecedoresproduto = response.data;
                    $('#mdfornecedores').modal('show');
                }
            }).catch(function (response) {
                vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
            });                
        },
        mtdexpandirnotas(indice){
            if (parseInt(this.lstfornecedoresproduto[indice].expandir) === 1){
                this.lstfornecedoresproduto[indice].expandir = 0;
            }else{
                this.lstfornecedoresproduto[indice].expandir = 1;
            }
        },
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        } 
    },
    mounted: function() {
        let vself = this;
        $("#mdfornecedores").on('shown.bs.modal', function(){
            vself.mtdfornecedoresproduto();
        });
        $("#mdfornecedores").on('hide.bs.modal', function(){
            vself.lstfornecedoresproduto = [];
        });                        
    },    
    computed:{ 
    },
    watch: {
    }
}
</script>
<style>
    #mdfornecedores{
        z-index: 2001!important;
    }    
</style>